import { StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { Input } from '../../components-v2/Input';
import { InputGroupAddon, InputGroupButton, InputGroupInput, InputGroupV2 } from '../../components-v2/InputGroup';
import { EyeIcon } from '../svgs/icons/EyeIcon';
import { EyeSlashIcon } from '../svgs/icons/EyeSlashIcon';

export interface IPasswordInputProps extends Omit<React.ComponentProps<'input'>, 'type'> {
	showToggleButton?: boolean;
	wrapperStyles?: StyleDeclarationValue[];
}

export const PasswordInput = React.forwardRef<HTMLInputElement, IPasswordInputProps>(
	({ showToggleButton = true, wrapperStyles, id, ...restProps }, ref) => {
		const resolvedId = id;
		const [isVisible, setIsVisible] = React.useState(false);
		const toggleVisibility = React.useCallback(() => setIsVisible(prev => !prev), []);

		if (!showToggleButton) {
			return <Input ref={ref} id={resolvedId} {...restProps} type={isVisible ? 'text' : 'password'} />;
		}

		return (
			<InputGroupV2 styles={wrapperStyles}>
				<InputGroupInput ref={ref} id={resolvedId} {...restProps} type={isVisible ? 'text' : 'password'} />
				<InputGroupAddon align='inlineEnd'>
					<InputGroupButton
						tabIndex={-1}
						aria-label={isVisible ? 'Hide password' : 'Show password'}
						onClick={toggleVisibility}
						size='iconXs'
					>
						{isVisible ? <EyeIcon /> : <EyeSlashIcon />}
					</InputGroupButton>
				</InputGroupAddon>
			</InputGroupV2>
		);
	}
);
PasswordInput.displayName = 'PasswordInput';
